'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroPlaceholder = require('./NitroPlaceholder');

var _NitroPlaceholder2 = _interopRequireDefault(_NitroPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroPlaceholder2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-placeholder/index.js
// module id = 65
// module chunks = 4